{
    "common": {
        "mon": "Ma",
        "tue": "Di",
        "wed": "Wo",
        "thu": "Do",
        "fri": "Vr",
        "sat": "Za",
        "sun": "Zo",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mrt",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dec",
        "january": "Januari",
        "february": "Februari",
        "march": "Maart",
        "april": "April",
        "may": "Mei",
        "june": "Juni",
        "july": "Juli",
        "august": "Augustus", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "December",
        "checkin": "Inchecken",
        "checkout": "Uitchecken",
        "room": "Kamer",
        "rooms": "Kamers",
        "adult": "Volwassene",
        "adults": "Volwassenen",
        "edit": "Bewerken",
        "editCap": "BEWERKEN",
        "delete": "Verwijderen",
        "deleteCap": "VERWIJDEREN",
        "localTime": "Lokale Tijd",
        "back": "TERUG",
        "home": "HOME",
        "yes": "JA",
        "no": "NEE",
        "left": "Over",
        "hour": "Uur",
        "hours": "Uren",
        "night": "nacht",
        "nights": "nachten",
        "for": "voor",
        "why": "Waarom",
        "get": "Krijg",
        "more": "Meer",
        "agree": "AKKOORD",
        "disagree": "NIET AKKOORD",
        "basedOn": "gebaseerd op",
        "error": "Er is een fout opgetreden, probeer het later opnieuw",
        "error2": "Mislukt, probeer opnieuw!",
        "error3": "Er is een fout opgetreden!!",
        "error4": "Er is een fout opgetreden!! Probeer het opnieuw",
        "error5": "Sorry!! Er is een fout opgetreden. Probeer het later opnieuw.",
        "hi": "Hallo",
        "to": "naar",
        "free": "Gratis",
        "per": "Per",
        "at": "om",
        "day": "Dag",
        "days": "Dagen",
        "time": "Tijd",
        "of": "van",
        "photo": "Foto",
        "photos": "Foto's",
        "done": "Klaar",
        "fullStay": "Volledig Verblijf",
        "date": "Datum",
        "and": "en",
        "bookingDetail": "Boekingsdetails",
        "Back": "Terug",
        "Home": "Home"
    },
    "userPopup": {
        "myAccount": "Mijn Account",
        "welcome": "Welkom",
        "user": "Gebruiker",
        "findMyBookings": "MIJN BOEKINGEN VINDEN",
        "viewProfile": "PROFIEL BEKIJKEN",
        "makeAReservarion": "RESERVERING MAKEN",
        "logout": "UITLOGGEN",
        "loginCap": "INLOGGEN",
        "login": "Inloggen",
        "invalidCredentials": "Ongeldige inloggegevens",
        "invalidEmail": "Ongeldig e-mailadres",
        "passwordIsRequired": "Wachtwoord is verplicht",
        "minChar8": "minimaal 8 tekens",
        "tooShort": "Te Kort!",
        "tooLong": "Te Lang!",
        "required": "Verplicht",
        "emailInvalid": "Voer een geldig e-mailadres in",
        "passwordInvalid": "Voer een geldig wachtwoord in",
        "phNumInvalid": "Telefoonnummer is niet geldig",
        "signupCap": "REGISTREREN",
        "signup": "Registreren",
        "verifyText": "Verifieer dat jij het bent",
        "verifyText2": "We hebben een verificatiecode naar je e-mailadres gestuurd",
        "verificationCode": "Verificatiecode",
        "didNotReceiveEmail": "Geen e-mail ontvangen",
        "clickToResend": "Klik om opnieuw te verzenden",
        "verifyAndSignIn": "Verifiëren en Inloggen",
        "otpSentSuccessfully": "OTP succesvol verzonden",
        "somethingWentWrong": "Er ging iets mis, probeer het opnieuw",
        "otpError": "Voer een geldig nummer in",
        "otpError2": "Voer alleen cijfers in",
        "otpError3": "Onjuiste OTP, probeer het opnieuw",
        "otpError4": "OTP verlopen, klik op Opnieuw verzenden",
        "otpError5": "Probeer het opnieuw",
        "forgetPassword": "Wachtwoord Vergeten",
        "submitError": "Gebruiker bestaat niet!",
        "userExistError": "Gebruiker Bestaat Al",
        "checkYourEmail": "Controleer je e-mail",
        "passwordResetLinkSent": "We hebben een link voor wachtwoordherstel gestuurd naar",
        "noWorriesResetInstructions": "Geen zorgen, we sturen je de instructies voor het resetten.",
        "enterYourEmail": "Voer je e-mailadres in",
        "resetMyPassword": "WACHTWOORD RESETTEN",
        "setANewPassword": "Stel een nieuw wachtwoord in",
        "newPassword": "Nieuw Wachtwoord",
        "confirmPassword": "Bevestig Wachtwoord",
        "confirmPasswordError": "Wachtwoorden moeten overeenkomen",
        "backToLogin": "Terug naar Inloggen",
        "dontHaveAccount": "Heb je geen account?",
        "alreadyHaveAccount": "Heb je al een account?",
        "memberDiscount1": "Je krijgt",
        "memberDiscount2": "ledenkorting voor altijd.",
        "discount1": "Beheer al je reserveringen op één plek.",
        "discount2": "Meld je aan voor gepersonaliseerde aanbevelingen en ervaringen op maat!!",
        "discount3": "Word lid van onze community van tevreden gasten en begin met het plannen van je verblijf.",
        "leftGridText1": "Beheer al je reserveringen op één plek",
        "leftGridText2": "Meld je aan voor gepersonaliseerde aanbevelingen en ervaringen op maat!!",
        "leftGridText3": "Word lid van onze community van tevreden gasten en begin met het plannen van je verblijf",
        "gridDiscountText1": "ledenkorting op",
        "gridDiscountText2": "geselecteerde accommodaties voor altijd",
        "gridDiscountText3": "Log in voor een ervaring op maat voor altijd",
        "gridDiscountText4": "Ontvang Exclusieve Ledenvoordelen",
        "findBookingError": "Je e-mailadres en reserverings-ID komen niet overeen",
        "verifyAndConfirmBooking": "Verifieer en bevestig boeking",
        "confirmEmailText": "We hebben een verificatiecode naar je e-mailadres gestuurd",
        "enterCodeText": "Voer de verificatiecode in die naar je is gestuurd",
        "didNotRecieveEmail": "Geen e-mail ontvangen?",
        "changeEmailText": "Klik hier om het e-mailadres te wijzigen",
        "verifyAndConfirm": "Verifiëren en Bevestigen",
        "verified": "GEVERIFIEERD",
        "bookingExpired": "Boeking Verlopen",
        "bookingExpiredText": "Het spijt ons, de boekings-ID die je gebruikt is verlopen",
        "backToFindingBooking": "Terug naar Boeking Zoeken",
        "findMyBooking": "Mijn Boekingen Vinden",
        "bookingEmail": "Boekings E-mail",
        "reservationId": "Reserverings-ID",
        "findBooking": "BOEKING ZOEKEN",
        "abandonmentCartDoneText1": "Bedankt!",
        "abandonmentCartDoneText2": "Je winkelwagengegevens zijn naar de e-mail gestuurd. Ga op elk moment verder met je boeking.",
        "Recommended Currencies": "Aanbevolen Valuta's",
        "All currencies": "Alle valuta's",
        "thisIsRequiredField": "Dit is een verplicht veld"
    },
    "widget": {
        "destination": "Bestemming",
        "enterDestination": "Voer Bestemming In",
        "guests": "Gasten",
        "guest": "Gast",
        "nationality": "Nationaliteit",
        "selectNationality": "Selecteer nationaliteit",
        "nationalityIsRequired": "Nationaliteit is verplicht",
        "selectedRate": "Speciaal tarief",
        "search": "Zoeken",
        "ages": "Leeftijden",
        "orAbove": "Of Ouder",
        "child": "Kind",
        "children": "Kinderen",
        "addAnotherRoom": "Nog Een Kamer Toevoegen",
        "removeRoom": "Kamer Verwijderen",
        "property": "Accommodatie",
        "city": "Stad",
        "country": "Land",
        "bookNow": "Nu Boeken",
        "overnightStay": "Overnachting",
        "dayUse": "Daggebruik",
        "destinationIsRequired": "Bestemming is verplicht",
        "checkInIsRequired": "Incheckdatum is verplicht",
        "checkOutIsRequired": "Uitcheckdatum is verplicht",
        "noLocationFound": "Geen Locatie Gevonden",
        "soldOut": "Uitverkocht",
        "highDemand": "Hoge Vraag",
        "dates": "Data",
        "allRates": "Alle tarieven zijn in",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Uitchecken op dezelfde dag"
    },
    "promotion": {
        "headingText": "Belangrijke Informatie voor",
        "regularRate": "Geen",
        "seniorCitizen": "Seniorentarief",
        "agencyRate": "Reisbureau Tarief",
        "caaRate": "CAA/AAA Tarief",
        "corporateRate": "Zakelijk Tarief",
        "governmentRate": "Overheid/Militair Tarief",
        "promotionalSpecialRate": "Promotie/Speciaal Tarief",
        "regularRateDescription": "Geen promotie toegepast.",
        "seniorCitizenRateDescription": "Dit is een kortingstarief voor hotels dat uitgebreid beschikbaar is voor oudere volwassenen, meestal 60 jaar of ouder.",
        "agencyRateDescription": "Dit is een kortingstarief voor hotels dat alleen toegankelijk is via specifieke reisbureaus ter bevordering van partnerschap en samenwerking.",
        "caaRateDescription": "Dit is een speciaal hoteltarief aangeboden aan leden van de AAA of CAA voor exclusieve besparingen.",
        "corporateRateDescription": "Dit is een kortingstarief voor hotels aangeboden aan zakenreizigers, meestal onderhandeld tussen het hotel en de zakelijke entiteit.",
        "governmentRateDescription": "Dit tariefplan biedt specifieke kortingen voor overheids-/militair personeel voor het boeken van een hotelkamer.",
        "contentSeniorCitizen": "Geboortebewijs is verplicht bij het inchecken. Het niet kunnen tonen van een geldig identiteitsbewijs resulteert in het in rekening brengen van de geldende tarieven.",
        "contentAgencyRate": "Zorg ervoor dat u uw boekingsbevestiging en identiteitsbewijs bij aankomst bij u heeft. Het niet kunnen tonen hiervan resulteert in standaardtarieven.",
        "contentPromotionalSpecialRate": "Dit is een kortingstarief voor hotels dat voor beperkte tijd wordt aangeboden, vaak gekoppeld aan specifieke evenementen, seizoenen of marketingcampagnes.",
        "contentCaaRate": "Zorg ervoor dat u uw CAA-lidmaatschapskaart of relevante identificatie bij het inchecken bij u heeft. Het niet kunnen tonen van een geldig ID resulteert in het in rekening brengen van de geldende tarieven.",
        "contentCorporateRate": "Bewijs van bedrijfs-ID of andere officiële documentatie is vereist bij het inchecken. Het niet kunnen tonen van relevant bewijs resulteert in het in rekening brengen van de geldende tarieven.",
        "contentGovernmentRate": "Een geldig overheids- of militair identiteitsbewijs moet worden overlegd bij het inchecken. Het niet verstrekken van de vereiste identificatie resulteert in standaardtarieven.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "TOEPASSEN",
        "Offer Code": "Aanbiedingscode",
        "Agency Code": "Reisbureau Code",
        "Corporate Code": "Zakelijke Code",
        "All-Access Rate": "All-Access Tarief",
        "errorCode": "Deze code is niet geldig"
    }
}
